import { render, staticRenderFns } from "./InternalFormSubmitted.vue?vue&type=template&id=7a5e2242"
import script from "./InternalFormSubmitted.vue?vue&type=script&lang=js"
export * from "./InternalFormSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports